import React, { useCallback } from 'react'
import { boolStr } from 'helpers/utils'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import { formatDateTime } from 'common/usual'

const MoveInstructionTextTable = (props) => {
  const { data, page, onPageChange } = props

  const goToDetail = useCallback(id => {
    props.history.push(`/move-instruction-texts/${id}`)
  }, [props.history])

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Move Resource Name</TableCell>
                  <TableCell>Text</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                  <TableRow key={record.id} className='cursor-pointer' onClick={() => goToDetail(record.id)}>
                    <TableCell>{record.id}</TableCell>
                    <TableCell>{record.move_resource?.name} ({record?.move_resource?.id})</TableCell>
                    <TableCell title={record.text}>
                      {record.text?.length > 50 ? record.text.substring(0, 50) + '...' : record.text}
                    </TableCell>
                    <TableCell>{boolStr(record.active)}</TableCell>
                    <TableCell>{formatDateTime(record.created_at)}</TableCell>
                    <TableCell>
                      {/* <EditBtn path={`/move-instruction-texts/${record.id}`} {...props} /> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={(data && data.count) || 0}
          onPageChange={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default MoveInstructionTextTable 